import React, { useEffect, useRef } from 'react';
import { cn } from '@/lib/utils';

interface EmailIframePreviewProps {
  html: string;
  height?: number | string;          // optional fixed height
  full?: boolean;                    // when true, take all available vertical space
  className?: string;
}

export default function EmailIframePreview({
  html,
  height = 300,
  full = false,
  className
}: EmailIframePreviewProps) {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;
    const doc = iframe.contentDocument;
    if (!doc) return;
    doc.open();
    doc.write(html || '<!doctype html><html><body style="font:12px system-ui;padding:16px;color:#ccc;">(Empty)</body></html>');
    doc.close();
  }, [html]);

  return (
    <div
      className={cn(
        'email-iframe-wrapper w-full',
        full ? 'h-full flex flex-col min-h-0' : '',
        className
      )}
    >
      <iframe
        ref={iframeRef}
        title="Email Preview"
        className={cn(
            'w-full bg-white dark:bg-zinc-900',
            full ? 'flex-1 h-full' : ''
        )}
        // Only apply explicit height when not in full mode
        style={!full ? { height: typeof height === 'number' ? `${height}px` : height } : {}}
        sandbox="allow-same-origin"
      />
    </div>
  );
}